module.exports = __webpack_public_path__ + "static/media/grau_azeton.76d8b57e.jpg";